// Image utility functions
export const getImagePath = (imageName) => {
  return `/images/${imageName}`;
};

// Image optimization helper
export const getOptimizedImagePath = (imageName) => {
  const basePath = `/images/${imageName}`;
  
  // For now, return the original path
  // In production, you might want to use a CDN or image optimization service
  return basePath;
};

// Responsive image helper
export const getResponsiveImageSrc = (imageName, sizes = []) => {
  const basePath = `/images/${imageName}`;
  
  // Generate srcset for different screen sizes
  if (sizes.length === 0) {
    return basePath;
  }
  
  const srcset = sizes.map(size => {
    // const filename = imageName.replace(/\.[^/.]+$/, "");
    // const extension = imageName.split('.').pop();
    return `${basePath} ${size}w`;
  }).join(', ');
  
  return {
    src: basePath,
    srcSet: srcset,
    sizes: sizes.map(size => `(max-width: ${size}px) ${size}px`).join(', ')
  };
};

// Common image configurations
export const IMAGE_CONFIGS = {
  logo: {
    src: getImagePath('n_1.png'),
    alt: 'PortRay ロゴ',
    width: 200,
    height: 50
  },
  serviceImage: {
    src: getImagePath('ServiceImg.png'),
    alt: 'サービス画像',
    width: 600,
    height: 400
  },
  youtubeChannel1: {
    src: getImagePath('YOutubeCH.png'),
    alt: '転職系アニメチャンネル',
    width: 300,
    height: 200
  },
  youtubeChannel2: {
    src: getImagePath('YOutubeCH2.png'),
    alt: 'リアルな仕事1日密着',
    width: 300,
    height: 200
  },
  topImage: {
    src: getImagePath('topsphere.png'),
    alt: 'トップ画像',
    width: 400,
    height: 300
  }
};
